import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full w-full" }
const _hoisted_2 = { class: "justify-end items-center p-2 hidden md:flex space-x-2" }
const _hoisted_3 = { class: "justify-end items-center p-2 hidden md:flex space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 搜索课程 ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mt-7 mx-0 mb-5 text-xl flex-initial flex-shrink-0 flex justify-center text-gray-800 md:hidden" }, " 搜索课程 ", -1)
const _hoisted_7 = { class: "flex flex-col justify-start relative w-full h-full flex-grow" }
const _hoisted_8 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_9 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_10 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_11 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_12 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_13 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_14 = { class: "w-full h-16 py-0 px-4 flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 节次 ")
const _hoisted_16 = { class: "flex-auto overflow-y-auto mt-3 bg-gray-100" }
const _hoisted_17 = { class: "w-full h-full rounded-b overflow-auto" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-lg text-gray-600" }
const _hoisted_20 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis text-sm text-gray-600" }
const _hoisted_21 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_22 = { class: "justify-end items-center p-2 md:hidden space-x-2 flex" }
const _hoisted_23 = { class: "justify-end items-center p-2 md:hidden space-x-2 flex flex-wrap" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 关闭 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 搜索课程 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_input = _resolveComponent("f-input")!
  const _component_f_select = _resolveComponent("f-select")!
  const _component_a_slider = _resolveComponent("a-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_f_button, {
        class: "w-full",
        type: _ctx.isSearchResultsVisible ? 'primary' : undefined,
        shape: "circle",
        size: "large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSearchResultsVisible = !_ctx.isSearchResultsVisible))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            style: _normalizeStyle(_ctx.isSearchResultsVisible ? 'color: #fff' : undefined),
            name: _ctx.isSearchResultsVisible ? 'contract' : 'expand',
            size: "20"
          }, null, 8, ["style", "name"]),
          _createTextVNode(" " + _toDisplayString(_ctx.isSearchResultsVisible ? '收起搜索结果' : '展开搜索结果'), 1)
        ]),
        _: 1
      }, 8, ["type"]), [
        [_vShow, _ctx.searchResults.length !== 0]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_f_button, {
        disabled: _ctx.isLoadingSearchResults || _ctx.isSearchQueryEmpty,
        shape: "circle",
        size: "large",
        onClick: _ctx.resetSearchQuery
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            name: "undo",
            size: "20"
          }),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_f_button, {
        disabled: _ctx.isLoadingSearchResults || _ctx.isSearchQueryEmpty,
        loading: _ctx.isLoadingSearchResults,
        type: "primary",
        shape: "circle",
        size: "large",
        onClick: _ctx.search
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            name: "search",
            size: "20"
          }),
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    _hoisted_6,
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_f_input, {
          ref: "textfield1",
          modelValue: _ctx.searchQuery.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery.name) = $event)),
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          "success-messages": 
            _ctx.searchBarStatus === 'success' ? `找到 ${_ctx.searchResults.length} 门课程` : []
          ,
          "error-messages": _ctx.searchBarStatus === 'error' ? '没有找到符合条件的课程' : [],
          label: "课程名",
          hint: "e.g. 文学（不分大小写）",
          outlined: "",
          dense: "",
          autocomplete: "off",
          class: "flex-grow",
          onKeydown: _ctx.handleKeyDown
        }, null, 8, ["modelValue", "disabled", "success-messages", "error-messages", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_f_input, {
          ref: "textfield4",
          modelValue: _ctx.searchQuery.codeId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery.codeId) = $event)),
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          success: _ctx.searchBarStatus === 'success' && _ctx.searchQuery.codeId.trim() !== '',
          error: _ctx.searchBarStatus === 'error' && _ctx.searchQuery.codeId.trim() !== '',
          label: "课程号",
          hint: "e.g. Engl（不分大小写）",
          outlined: "",
          dense: "",
          autocomplete: "off",
          class: "flex-grow",
          onKeydown: _ctx.handleKeyDown
        }, null, 8, ["modelValue", "disabled", "success", "error", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_f_input, {
          ref: "textfield2",
          modelValue: _ctx.searchQuery.teachers,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery.teachers) = $event)),
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          success: _ctx.searchBarStatus === 'success' && _ctx.searchQuery.teachers.trim() !== '',
          error: _ctx.searchBarStatus === 'error' && _ctx.searchQuery.teachers.trim() !== '',
          label: "授课教师",
          hint: "请输入教师全名，多名教师可用逗号分隔",
          outlined: "",
          dense: "",
          autocomplete: "off",
          class: "flex-grow",
          onKeydown: _ctx.handleKeyDown
        }, null, 8, ["modelValue", "disabled", "success", "error", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_f_input, {
          ref: "textfield5",
          modelValue: _ctx.searchQuery.place,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQuery.place) = $event)),
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          success: _ctx.searchBarStatus === 'success' && _ctx.searchQuery.place.trim() !== '',
          error: _ctx.searchBarStatus === 'error' && _ctx.searchQuery.place.trim() !== '',
          label: "上课地点",
          hint: "e.g. Hgx（不分大小写）",
          outlined: "",
          dense: "",
          autocomplete: "off",
          class: "flex-grow",
          onKeydown: _ctx.handleKeyDown
        }, null, 8, ["modelValue", "disabled", "success", "error", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_f_input, {
          ref: "textfield3",
          modelValue: _ctx.searchQuery.department,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchQuery.department) = $event)),
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          success: _ctx.searchBarStatus === 'success' && _ctx.searchQuery.department.trim() !== '',
          error: _ctx.searchBarStatus === 'error' && _ctx.searchQuery.department.trim() !== '',
          label: "开课院系",
          hint: "e.g. 马克思",
          outlined: "",
          dense: "",
          autocomplete: "off",
          class: "flex-grow",
          onKeydown: _ctx.handleKeyDown
        }, null, 8, ["modelValue", "disabled", "success", "error", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_f_select, {
          modelValue: _ctx.searchQuery.day,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchQuery.day) = $event)),
          class: "flex-grow",
          options: ['全部', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
          disabled: _ctx.isLoadingSearchResults || _ctx.isLoadingCourses,
          success: _ctx.searchBarStatus === 'success' && _ctx.searchQuery.day !== '全部',
          error: _ctx.searchBarStatus === 'error' && _ctx.searchQuery.day !== '全部',
          label: "星期",
          autocomplete: "off"
        }, null, 8, ["modelValue", "disabled", "success", "error"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_a_slider, {
          value: _ctx.searchQuery.sectionRange,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchQuery.sectionRange) = $event)),
          class: "flex-grow ml-2",
          range: "",
          dots: "",
          marks: _ctx.sectionLabels,
          min: 0,
          max: 13
        }, null, 8, ["value", "marks"])
      ])
    ], 512), [
      [_vShow, !(_ctx.isSearchResultsVisible && _ctx.searchResults.length !== 0)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, [
      _withDirectives(_createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.courseId,
            class: "f-clickable bg-white mt-2 shadow-md p-5 rounded-lg text-sm text-gray-500",
            onClick: _withModifiers(($event: any) => (_ctx.$emit('add-course', item.courseId)), ["stop"])
          }, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(`${item.codeId} ${item.name}`), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(item.teachersText), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.timeSlotsTexts.slice(0, 3), (ts, tsIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tsIndex,
                class: "text-xs text-gray-500"
              }, _toDisplayString(ts), 1))
            }), 128)),
            (item.timeSlotsTexts.length > 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " …… "))
              : _createCommentVNode("", true)
          ], 8, _hoisted_18))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isSearchResultsVisible && _ctx.searchResults.length !== 0]
      ])
    ], 512), [
      [_vShow, _ctx.isSearchResultsVisible && _ctx.searchResults.length !== 0]
    ]),
    _createElementVNode("div", _hoisted_22, [
      _withDirectives(_createVNode(_component_f_button, {
        type: _ctx.isSearchResultsVisible ? 'primary' : undefined,
        shape: "circle",
        size: "large",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isSearchResultsVisible = !_ctx.isSearchResultsVisible))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            style: _normalizeStyle(_ctx.isSearchResultsVisible ? 'color: #fff' : undefined),
            name: _ctx.isSearchResultsVisible ? 'contract' : 'expand',
            size: "20"
          }, null, 8, ["style", "name"]),
          _createTextVNode(" " + _toDisplayString(_ctx.isSearchResultsVisible ? '收起搜索结果' : '展开搜索结果'), 1)
        ]),
        _: 1
      }, 8, ["type"]), [
        [_vShow, _ctx.searchResults.length !== 0]
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_f_button, {
        disabled: _ctx.isLoadingSearchResults || _ctx.isSearchQueryEmpty,
        shape: "circle",
        size: "large",
        onClick: _ctx.resetSearchQuery
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            name: "undo",
            size: "20"
          }),
          _hoisted_24
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_f_button, {
        disabled: _ctx.isLoadingSearchResults,
        shape: "circle",
        size: "large",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('hide-search-dialog')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            name: "arrawsalt",
            size: "20"
          }),
          _hoisted_25
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_f_button, {
        disabled: _ctx.isLoadingSearchResults || _ctx.isSearchQueryEmpty,
        loading: _ctx.isLoadingSearchResults,
        type: "primary",
        shape: "circle",
        size: "large",
        onClick: _ctx.search
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_icon, {
            name: "search",
            size: "20"
          }),
          _hoisted_26
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ])
  ]))
}